export const analyticsPath = "/analytics";

export const analyticsUrl = (): string => analyticsPath;
